module.exports = __webpack_public_path__ + "img/table-icon-robot.7b48fe8c.png";